import React from 'react';
import { Button } from 'antd';
import { Edit, Checkmark } from '@carbon/icons-react';

export function CardEdit({ isEditing, onEdit, onSave, onCancel, loading = false }) {
  if (isEditing) {
    return (
      <div className="flex items-center gap-2">
        <Button type="primary" size="small" onClick={onSave} loading={loading}>
          <span>Save</span>

          <Checkmark size={18} className="ml-[-4px]" />
        </Button>

        {onCancel && (
          <Button size="small" onClick={onCancel} danger disabled={loading}>
            Cancel
          </Button>
        )}
      </div>
    );
  }

  return (
    <Button className="card-edit" size="small" color="primary" variant="outlined" icon={<Edit />} onClick={onEdit}>
      Edit
    </Button>
  );
}
